import React from "react";
import BusinessesPage from "@pages/Businesses/BusinessesPage";
import BusinessEditorPage from "@pages/Businesses/BusinessEditorPage";
import ProtectedRoute from "@components/routes/ProtectedRoute";
import SetBusinessAdminPage from "@pages/Businesses/SetBusinessAdminPage";

export default [
    {
        path: "businesses",
        element: <ProtectedRoute allowedRoles={["root_admin"]} />,
        children: [
            {
                path: "",
                element: <BusinessesPage />,
            },
            {
                path: "editor",
                element: <BusinessEditorPage />,
            },
            {
                path: "set-admin",
                element: <SetBusinessAdminPage />,
            },
        ],
    },
];
